const GC = window.__GENERATED_CONSTANTS__

export const reportUrls = GC.reportUrls
export const reportNameKeys = GC.reportNameKeys

// only used in next
export const TaskPredefinedFieldNames = {
    Deadline: 'Deadline',
    TypeOfWork: 'TypeOfWork',
}

/**
 * !! Don't change value without corresponding change in next web
 */
export const AtNextCustomScrollbarUsedClassName = '_internal_atNextCustomScrollbarUsed'

export const ApiErrorKeys = {
    NotFoundEntity: 'not_found.entity'
}

export const ApiEntityTypes = {
    CustomField: 'custom_field'
}



// WEBPACK FOOTER //
// ./web/js/next/constants.js